import { colors } from "@dotnet/telematics-design-system";

import { RectangleLoader } from "shared/loaders/RectangleLoader";

const RectangularSkeleton = () => {
    const { blue100 } = colors;

    return (
        <div>
            <RectangleLoader
                width={152}
                height={32}
                backgroundColor={blue100}
            />
        </div>
    );
};

export default RectangularSkeleton;
